// @flow
import React from 'react';
import { CurrencyZeroDPRenderer, PercentageRenderer } from '@components/views/grid-utils/renderers';
import { PaddedAndRaisedSegment } from '@presentational/PaddedAndRaisedSegment';
import { DataGrid } from '@components/views/grid-utils/DataGrid';
import { DEFAULT_COLUMN_DEFINITION_FOR_SIMPLIFIED_GRID } from '@components/views/grid-utils/constants';
import { TOTAL_COMMITMENT, GLOBAL_DISCOUNT } from '@src/constants';

import { useShouldPricingBeDisabled } from '../useShouldPricingBeEnabled';

const SFDCFieldsRenderer = (props) => {
  if (props.data.Field === TOTAL_COMMITMENT) {
    return CurrencyZeroDPRenderer(props);
  }

  if (props.data.Field === GLOBAL_DISCOUNT) {
    return PercentageRenderer(props);
  }

  return props.value;
};

export const SPUserCommitSFDCFieldsViewsContainer = ({ data }) => {
  const inputDataSource = data?.sfdc_fields ?? [];

  const columnDefs = [
    {
      field: 'Field',
      backEndFieldName: 'field',
      minWidth: 400,
    },
    {
      field: 'Value',
      backEndFieldName: 'value',
      minWidth: 100,
      cellRenderer: SFDCFieldsRenderer,
    },
  ];

  const shouldPricingBeDisabled = useShouldPricingBeDisabled();

  return (
    <PaddedAndRaisedSegment disabled={shouldPricingBeDisabled}>
      <DataGrid
        columnDefs={columnDefs}
        defaultColDef={DEFAULT_COLUMN_DEFINITION_FOR_SIMPLIFIED_GRID}
        inputDataSource={inputDataSource}
        label="SFDC Fields to Populate"
        noHeader={true}
        width="665px"
      />
    </PaddedAndRaisedSegment>
  );
};
